import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const mentalRoutes: CustomRouteRecordRaw = {
  path: 'mental',
  name: 'mental',
  component: EmptyLayout,
  redirect: { name: 'workbench' },
  meta: {
    title: '九型人格测试',
    iconfont: 'icon-user-search-line',
    requiredPermission: 'mental',
  },
  children: [
    {
      path: 'character-list',
      name: 'characterList',
      component: () => import('@/views/mental/character-list.vue'),
      meta: {
        title: '性格列表',
        requiredPermission: 'mental.character.list',
      }
    },
    {
      path: 'mental-test-list',
      name: 'mentalTestList',
      component: () => import('@/views/mental/mental-test-list.vue'),
      meta: {
        title: '测评套餐',
        requiredPermission: 'mental.test.list'
      },
    },
    {
      path: 'mental-test-create',
      name: 'mentalTestCreate',
      component: () => import('@/views/mental/mental-test-create.vue'),
      meta: {
        hideInMenu: true,
        title: '新增测评套餐',
        requiredPermission: 'mental.test.create',
      },
    },
    {
      path: 'mental-test-edit/:id',
      name: 'mentalTestEdit',
      component: () => import('@/views/mental/mental-test-edit.vue'),
      meta: {
        hideInMenu: true,
        title: '编辑测评套餐',
        requiredPermission: 'mental.test.edit',
      },
    },
    {
      path: 'pay-log',
      name: 'payLog',
      component: () => import('@/views/mental/pay-log.vue'),
      meta: {
        title: '测评记录',
        requiredPermission: 'mental.pay.log',
      },
    },
    {
      path: 'mental-test-report',
      name: 'mentalTestReport',
      component: () => import('@/views/mental/mental-test-report.vue'),
      meta: {
        title: '报告列表',
        requiredPermission: 'mental.test.report',
      },
      // props: {
      //   type: 2
      // }
    },
    {
      path: 'character-create',
      name: 'characterCreate',
      component: () => import('@/views/mental/character-create-edit.vue'),
      meta: {
        hideInMenu: true,
        title: '新增性格',
        requiredPermission: 'mental.character.create',
      }
    },
    {
      path: 'character-edit/:id',
      name: 'characterEdit',
      component: () => import('@/views/mental/character-create-edit.vue'),
      meta: {
        hideInMenu: true,
        title: '性格编辑',
        requiredPermission: 'mental.character.edit',
      }
    }
  ],
}
